<template>
    <v-container>
        <v-layout row v-if="error"> 
            <v-flex xs12 sm6 offset-sm3>
                <app-alert @dismissed="onDismissed"
                :text="error.message" >
                </app-alert>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 sm6 offset-sm3>
                <v-card>
                    <v-card-text>
                        <form @submit.prevent="OnSignup">
                            <v-layout row>
                                <v-flex xs12 >
                                    <v-text-field
                                    name="email"
                                    label="Mail"
                                    id="email"
                                    v-model="email"
                                    type="email"
                                    required
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs12 >
                                    <v-text-field
                                    name="password"
                                    label="Password"
                                    id="password"
                                    v-model="password"
                                    type="password"
                                    required
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs12 >
                                    <v-text-field
                                    name="confirmPassword"
                                    label="Confirm Password"
                                    id="confirmPassword"
                                    v-model="confirmPassword"
                                    type="password"
                                    required
                                    :rules="[comparePasswords]"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs12>
                                    <v-btn type="submit" 
                                     :disabled="loading"
                                     :loading="loading">
                                       Sign Up
                                        <span slot="loader" class="custom-loader">
                                            <v-icon light>cached</v-icon>
                                        </span>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
    };
  },
  computed: {
    comparePasswords() {
      return this.password !== this.confirmpassword ?
        'Paswords do not match' : '';
    },
    user() {
      return this.$store.getters.user;
    },
    error() {
        return this.$store.getters.error; 
    },
    loading() {
        return this.$store.getters.loading;
    },
  },
  watch: {
    user(value) {
      if (value != null && value !== undefined) {
        this.$router.push('/');
      }
    },
  },
  methods: {
    OnSignup() {
      // Vuex
      console.log({
        email: this.email,
        password: this.password,
        confirmpassword: this.confirmpassword,
      });
      this.$store.dispatch('signUserUp', {
        email: this.email,
        password: this.password,
      });
    },
    onDismissed() {
      this.$store.dispatch('clearError');
    },
  },
};
</script>
